import { withAuthGate } from '@sunrise-ui/composites';
import IntrosMadeView from '@templates/IntrosMadeView';
import React from 'react';

function AcceptedIntrosMadeScreen() {
  return <IntrosMadeView state="accepted" />;
}

export default withAuthGate(AcceptedIntrosMadeScreen);
